import React, { Component } from 'react';
import './App.css';
import { Appbar, Button, Container } from 'muicss/react';
import Input from 'muicss/lib/react/input';
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom'
import {RaisedButton} from 'material-ui';
import firebase from 'firebase';
import Cookies from 'universal-cookie';

export class C92 extends Component {
  constructor(props) {
    super(props)
    console.log(props)
    this.state = this.configureStateFor(props)
  }

  download(path) {
    var storage = firebase.storage();
    var gsReference = storage.refFromURL(path)

    gsReference.getDownloadURL().then(function(url) {
      window.location = url
      console.log(`${url}`)
    }).catch(function(error) {
      alert(error)
    });
  }

  configureStateFor(props) {
    return {
      isLoggedIn: false
    }
  }

  componentDidMount () {
    firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          this.setState({
            isLoggedIn: true
          })
        } else {
          this.setState({
            isLoggedIn: false
          })
        }
    })
  }

  render() {
    const cookies = new Cookies()
    // ログイン済
    if (this.state.isLoggedIn) {
      console.log("<TOP(LOGIN)>")
      const user = firebase.auth().currentUser
      console.log(`${user.email} ${user.uid}`)
      const email = user.email ? `(${user.email})` : ""
      return (
        <div className="App">
          <image src={user.photoURL} />
          <p>ユーザ: {user.displayName} {email}</p>
          <p>シリアルキー: {cookies.get("serialNo")}</p>
          <RaisedButton primary onClick={() => {
            this.download("gs://motelab/B5.pdf")
          }}>
          (C92)SHIMAMURA[pdf版]を ダウンロード
          </RaisedButton>
          <hr/>
          <RaisedButton negative onClick={() => {
            firebase.auth().signOut().then(() => {
              console.log("SignOut")
            }, (error) => {
              console.error(error)
            });
          }}>
          ログアウト
          </RaisedButton>
        </div>
      )
    }
    // 未ログイン
    // TODO: Twitter, Facebookを追加
    console.log("<TOP(NOT LOGIN)>")
    var header = () => {
      if (cookies.get("serialNo")) {
        return <p>シリアルキー: {cookies.get("serialNo")}</p>
      } else {
        return <Input label="シリアルキー" type="text"/>
      }
    }
    return (
      <Container>
        <h3>[C92]「SHIMAMURA」ダウンロードサイト</h3>
        <h4>ダウンロードには「Google ID」または「Twitter」によるログインが必要です。</h4>
        <div>
          {header()}
          <Button color="danger" onClick={() => {
            var provider = new firebase.auth.GoogleAuthProvider();
            firebase.auth().signInWithRedirect(provider).then((result) => {
              var token = result.credential.accessToken
              var user = result.user
              console.log(`${user} ${this.state}`)
            }).catch((error) => {
              console.error(error)
              var errorCode = error.code
              var errorMessage = error.message
              var email = error.email
              var credential = error.credential
            })
          }}>
            Goodle IDでログイン
          </Button>
          <Button color="primary" onClick={() => {
            var provider = new firebase.auth.TwitterAuthProvider();
            provider.setCustomParameters({
              'lang': 'jp'
            });
            firebase.auth().signInWithRedirect(provider).then((result) => {
              var token = result.credential.accessToken
              var secret = result.credential.secret
              var user = result.user
              console.log(`${user} ${this.state}`)
            }).catch((error) => {
              console.error(error)
              var errorCode = error.code
              var errorMessage = error.message
              var email = error.email
              var credential = error.credential
            })
          }}>
            Twitterでログイン
          </Button>
        </div>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/c92.js